import { useLocation, useNavigate } from 'react-router-dom';
import { Home, Tag, ShoppingBag, Calendar } from 'lucide-react';
import '../assets/styles/MobileNav.css';

const NAV_ITEMS = [
  { icon: Home, label: 'Home', path: '/' },
  { icon: Tag, label: 'Prices', path: '/price' },
  { icon: ShoppingBag, label: 'Shop', path: '/shop' },
  { icon: Calendar, label: 'Book', path: '/book' },
];

export default function MobileNav() {
  const navigate = useNavigate();
  const { pathname } = useLocation();

  return (
    <nav className="mobile-nav" aria-label="Main navigation">
      {NAV_ITEMS.map(({ icon: Icon, label, path }) => {
        const active = pathname === path;
        const isBook = path === '/book';
        return (
          <button
            key={path}
            onClick={() => navigate(path)}
            className={[active ? 'active' : '', isBook ? 'book-tab' : ''].filter(Boolean).join(' ')}
            aria-label={label}
            aria-current={active ? 'page' : undefined}
          >
            <Icon size={20} strokeWidth={1.75} />
            <span>{label}</span>
          </button>
        );
      })}
    </nav>
  );
}
